import axiosClient from "@/lib/axios/axiosClient";

type RegenerateTranscriptionResponse = {
  fileId: number;
  message: string;
};

export const regenerateTranscription = async (
  fileId: number,
  audioTranscriptionProviderId: string
): Promise<RegenerateTranscriptionResponse> => {
  const response = await axiosClient.post<RegenerateTranscriptionResponse>(
    "/regenerate-transcription",
    {
      fileId: fileId,
      audioTranscriptionProviderId: audioTranscriptionProviderId,
    },
    {
      sendToken: true,
      headers: {
        Accept: "application/json",
        "Content-Type": "text/plain; charset=utf-8",
      },
    }
  );

  return response.data;
};
